import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
import { selectBalancingCharacter } from "./selectBalancingCharacters";
export var selectBalancingFarmEvents = function () { return utilBalancing.getBalancing().FarmEvents; };
export var selectBalancingFarmEventById = memoize(function (id) { return selectBalancingFarmEvents().get(id); });
export var selectBalancingFarmEventByEventType = memoize(function (type) {
    return Array.from(selectBalancingFarmEvents().values()).find(function (element) { return element.type === type; });
});
export var selectBalancingFarmEventIdByEventType = memoize(function (eventType) {
    var eventInfo = selectBalancingFarmEventByEventType(eventType);
    if (eventInfo == undefined) {
        return undefined;
    }
    return eventInfo.id;
});
export var selectTournamentLeagueMinimumLevel = memoize(function (tournamentId) {
    var event = selectBalancingFarmEventByEventType(tournamentId);
    return event != undefined ? event.requPlayerLevel : undefined;
});
export var selectBalancingFarmEventDisplayInfoByEventType = memoize(function (eventType) {
    var event = selectBalancingFarmEventByEventType(eventType);
    return event ? event.displayInfo : undefined;
});
export var selectBalancingFarmEventCharacterProfilePictureByEventType = memoize(function (eventType) {
    var balancingInfos = selectBalancingFarmEventDisplayInfoByEventType(eventType);
    var character = balancingInfos
        ? selectBalancingCharacter(balancingInfos.characterId)
        : undefined;
    return character ? character.profilePictureAsset : undefined;
});
export var balancingFarmEventsMemoizedFunctions = [
    selectBalancingFarmEvents,
    selectTournamentLeagueMinimumLevel,
    selectBalancingFarmEventById,
    selectBalancingFarmEventByEventType,
    selectBalancingFarmEventDisplayInfoByEventType,
    selectBalancingFarmEventCharacterProfilePictureByEventType,
    selectBalancingFarmEventIdByEventType,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingFarmEvents.ts
// module id = 191
// module chunks = 3